import axios from 'axios'
import store from '@/store'

let isRefreshing = false
let refreshQueue = []

function onTokenRefreshed(newToken) {
    refreshQueue.forEach(cb => cb(newToken))
    refreshQueue = []
}

const instance = axios.create({
    baseURL: '/',
    withCredentials: true
})

instance.interceptors.request.use(config => {
    if (config.url.includes('/auth/')) {
        return config;
    }

    const token = store.state.authModule.accessToken
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
})


// 🔹 Handle 401 + refresh token logic
instance.interceptors.response.use(
    res => res,
    async error => {
        const { response, config } = error
        if (!response) return Promise.reject(error)
        // VERY IMPORTANT
        if (config.url.includes('/auth/refresh')) {
            return Promise.reject(error)
        }
        if (response && response.status === 401 && !config._retry) {
            config._retry = true

            if (isRefreshing) {
                return new Promise(resolve => {
                    refreshQueue.push(newToken => {
                        config.headers.Authorization = `Bearer ${newToken}`
                        resolve(instance(config))
                    })
                })
            }
            isRefreshing = true
            const newToken =
                await store.dispatch('authModule/refreshAccessToken')
            isRefreshing = false
            if (!newToken) return Promise.reject(error)
            onTokenRefreshed(newToken)
            config.headers.Authorization = `Bearer ${newToken}`
            return instance(config)
        }
        return Promise.reject(error)
    }
)

export default instance
